import "./utils/counter";

jQuery(document).ready(function ($) {
  // Hamburger menu & Menu mobile
  $(".navbar-toggler").on("click", function () {
    $(".wrapper-menu-mobile").toggleClass("show");
    $(".navbar-toggler").toggleClass("is-toggled");
  });
  $(window).resize(function () {
    $(".wrapper-menu-mobile").removeClass("show");
    $(".navbar-toggler").removeClass("is-toggled");
  });
  // Dropdown menu
  $(".menu-item--expanded").click(function (e) {
    $(".menu-item--expanded")
      .not(this)
      .children()
      .removeClass("submenu-active");
    $(this).children().toggleClass("submenu-active");
  });
  $(document).on("click", function (e) {
    if ($(e.target).closest(".menu-item--expanded > *").length === 0) {
      $(".menu-item--expanded > .sub-menu").removeClass("submenu-active");
      $(".menu-item--expanded > .nav-link").removeClass("submenu-active");
    }
  });
  // Accordion
  $(".accordion__wrapper__title").on("click", function () {
    $(this).children(".accordion__icon").toggleClass("open");
  });
  const accordionBtns = document.querySelectorAll(".accordion__wrapper__title");
  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      this.classList.toggle("is-open");
      let content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };
  });

  // Apri l'accordion TOC di default e correggi altezza
  const tocAccordion = document.querySelector(
    ".toc .accordion__wrapper__title"
  );
  if (tocAccordion) {
    tocAccordion.classList.add("is-open");
    const tocIcon = tocAccordion.querySelector(".accordion__icon");
    if (tocIcon) {
      tocIcon.classList.add("open");
    }
    let content = tocAccordion.nextElementSibling;
    if (content) {
      // Correggi altezza dopo che la TOC è stata popolata
      const adjustHeight = () => {
        content.style.maxHeight = content.scrollHeight + "px";
      };
      // Esegui l'aggiustamento dopo la generazione dinamica della TOC
      setTimeout(adjustHeight, 100);
    }
  }

  // Generazione dinamica della TOC
  const tocList = document.querySelector(
    ".toc.auto .field--name-field-toc-text ul"
  );
  const articleHeadings = document.querySelectorAll(
    "article h2:not(.hero__page__wrapper h2)"
  );
  if (tocList && articleHeadings.length > 0) {
    articleHeadings.forEach((heading, index) => {
      // Genera un ID unico per ogni h2
      const textContent = heading.textContent.trim();
      const id = `${index}-${textContent.replace(/\s+/g, "-").toLowerCase()}`;
      heading.setAttribute("id", id);

      // Crea un elemento <li> con un link all'h2
      const listItem = document.createElement("li");
      const anchor = document.createElement("a");
      anchor.href = `#${id}`;
      anchor.textContent = textContent;

      // Aggiungi il link all'elemento <li> e aggiungilo alla TOC
      listItem.appendChild(anchor);
      tocList.appendChild(listItem);
    });
  }

  // swiper
  var cs2Swiper = new Swiper(".swiper-container", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      setTimeout(() => {
        location = "/grazie/";
      }, 1000);
    },
    false
  );
  // Marquee3k Initialization
  if (typeof Marquee3k !== "undefined") {
    Marquee3k.init();
    const marquee = $(".marquee3k");
    marquee.on("mouseover", Marquee3k.pauseAll);
    marquee.on("mouseout", Marquee3k.playAll);
  } else {
    console.error("Marquee3k is not loaded");
  }
  // init aos
  AOS.init();

  if ($("body").hasClass("woocommerce-cart")) {
    let cartUpdateTimer;

    $(document).on(
      "change input",
      ".woocommerce-cart-form input.qty, .woocommerce-cart-form input[name*='cart'][name*='qty']",
      function () {
        clearTimeout(cartUpdateTimer);
        $("input[name='update_cart']").removeAttr("disabled");

        const $input = $(this);
        const $item = $input.closest(".git-cart-item");

        if ($item.length) {
          $item.addClass("updating");
        }

        cartUpdateTimer = setTimeout(function () {
          $(document.body).trigger("wc_update_cart");
        }, 1000);
      }
    );

    $(document.body).on("updated_cart_totals updated_wc_div", function () {
      $(".git-cart-item").removeClass("updating");
    });
  }

  $(".git-product-images").each(function () {
    const $gallery = $(this);
    const mainDisplay = $gallery.find(".git-main-swiper")[0];
    const thumbnailDisplay = $gallery.find(".git-thumbs-swiper")[0];
    let tourCarousel = null;

    if (!mainDisplay || typeof Swiper === "undefined") {
      return;
    }

    if (mainDisplay.swiper && !mainDisplay.swiper.destroyed) {
      mainDisplay.swiper.destroy(true, true);
    }

    if (!thumbnailDisplay) {
      return;
    }

    if (thumbnailDisplay.swiper && !thumbnailDisplay.swiper.destroyed) {
      thumbnailDisplay.swiper.destroy(true, true);
    }

    const thumbsSwiper = new Swiper(thumbnailDisplay, {
      slidesPerView: "auto",
      spaceBetween: 12,
      freeMode: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
    });

    function syncActiveThumb(index) {
      const $thumbs = $gallery.find(".git-carousel-item");
      $thumbs.removeClass("active");
      $thumbs.eq(index).addClass("active");
    }

    function resetInactiveVideos(swiperInstance) {
      const $videoWrappers = $(swiperInstance.slides)
        .not(swiperInstance.slides[swiperInstance.activeIndex])
        .find(".git-video-wrapper");

      $videoWrappers.each(function () {
        const $wrapper = $(this);
        $wrapper.find(".git-video-player").empty().hide();
        $wrapper.find(".git-video-play-button").show();
        $wrapper.find(".git-video-preview-thumb").show();
      });
    }

    function initTourCarousel() {
      /*if (window.innerWidth > 767) {
        if (tourCarousel && !tourCarousel.destroyed) {
          tourCarousel.destroy(true, true);
          tourCarousel = null;
        }

        return;
      }*/

      if (tourCarousel && !tourCarousel.destroyed) {
        tourCarousel.update();
        return;
      }

      tourCarousel = new Swiper(mainDisplay, {
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 500,
        autoHeight: true,
        allowTouchMove: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        thumbs: {
          swiper: thumbsSwiper,
        },
        on: {
          init: function () {
            syncActiveThumb(this.activeIndex);
          },
          slideChange: function () {
            syncActiveThumb(this.activeIndex);
            resetInactiveVideos(this);
          },
        },
      });
    }

    $gallery.on("click", ".git-carousel-item", function () {
      const slideIndex = $(this).index();
      syncActiveThumb(slideIndex);
      if (tourCarousel && !tourCarousel.destroyed) {
        tourCarousel.slideTo(slideIndex);
      }
    });

    thumbsSwiper.update();
    initTourCarousel();
    syncActiveThumb(0);
    $(window).on("resize", initTourCarousel);
  });

  $(document).on("click", ".git-video-play-button", function () {
    const $button = $(this);
    const $videoWrapper = $button.closest(".git-video-wrapper");
    const $previewThumb = $videoWrapper.find(".git-video-preview-thumb");
    const $player = $videoWrapper.find(".git-video-player");
    const embedSrc = $videoWrapper.data("embed-src");

    if (!$player.length || !embedSrc) {
      return;
    }

    if ($previewThumb.length) {
      $previewThumb.hide();
    }

    $player.html(
      '<iframe src="' +
        embedSrc +
        '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen style="width: 100%; height: 100%; position: absolute; top: 0; left: 0;"></iframe>'
    );
    $button.hide();
    $player.show();
  });
});
